// ServiceDetailPage component - Converted from pages/service-detail.vue
// Uses shared service grid as a simple detail stand‑in
import React from 'react';
import HeaderOne from '../components/HeaderOne';
import ServiceOne from '../components/ServiceOne';
import Footer from '../components/Footer';

const ServiceDetailPage: React.FC = () => {
  React.useEffect(() => {
  }, []);

  return (
    <>
      <HeaderOne />
      {/* Using the generic services grid as a stand‑in for a single service view */}
      <ServiceOne />
      <Footer />
    </>
  );
};

export default ServiceDetailPage;
